import EventeMitter2 from "eventemitter2";
import log from "@src/common/utils/log";
class EventBus {
  constructor() {
    this.events = new Map();
    this.eventBus = new EventeMitter2({
      // 是否使用通配符
      wildcard: false,
      // 空间分隔符
      delimiter: ".",
      // 如果要发出newListener事件，请将其设置为`true`
      newListener: false,
      // 如果要发出removeListener事件，请将其设置为true
      removeListener: false,
      // the maximum amount of listeners that can be assigned to an event
      maxListeners: 100,
      // 当分配的侦听器数量超过最大数量时，在内存泄漏消息中显示事件名称
      verboseMemoryLeak: false,
      // 如果发出错误事件并且没有侦听器，则禁止抛出uncaughtException
      ignoreErrors: false
    });
  }
  /**
   *
   * @param {string} eveName
   * 如果是string表示事件名字,如果是对象表示一个事件处理的线程 {eveName: ''},这样可以防止多人使用时命名重复
   * 使用方式, 新建一个eventA.js {eveName: 'eventA'} 在需要引入时引入并触发addListener()
   * @param {function} callback
   */
  addListener(eveName, callback) {
    if (typeof eveName === "string") {
      if (!this.events.get(eveName)) {
        this.events.set(eveName, callback);
        this.eventBus.on(eveName, callback);
      } /*  else {
        log.warn(`该事件--${eveName}--已被注册，如使用请移除该事件`)
      } */
    }
  }
  /**
   *
   * @param {string} eveName
   * @param {any} payLoad 任意类型
   */
  emit(eveName, payLoad) {
    if (!this.events.get(eveName)) {
      // console.log(`该事件--${eveName}--不存在，如使用请注册该事件`);
    } else {
      this.eventBus.emit(eveName, payLoad);
    }
  }

  removeListeners(eveName) {
    if (this.events.get(eveName)) {
      this.eventBus.removeListener(eveName, this.events.get(eveName));
      this.events.delete(eveName);
    }
  }
  removeListenersAll() {
    this.events.clear();
    this.eventBus.removeAllListeners();
  }
}
export default new EventBus();
